import { render } from "./PdfSlot.vue?vue&type=template&id=58977ad6&scoped=true"
import script from "./PdfSlot.vue?vue&type=script&lang=js"
export * from "./PdfSlot.vue?vue&type=script&lang=js"

import "./PdfSlot.vue?vue&type=style&index=0&id=58977ad6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58977ad6"]])

export default __exports__